<template>
  <b-container fluid class="mt-4">
    <b-card class="mb-5" v-if="errorType === 'WRONG_PCCC'">
      <p>입력하신 개인통관고유부호: {{ logi.idno }}<br /></p>
      <p>{{ logi.savemsg }}</p>
      <p>
        <a
          target="_blank"
          href="https://unipass.customs.go.kr/csp/persIndexRectOnslCrtf.do?qryIssTp=2"
        >
          &lt;여기를 클릭하여 통관부호를 발급받은 후 개인통관고유부호 입력란에
          입력해주세요.&gt;
        </a>
      </p>
      <p>사업자등록번호 사용을 희망하시면 통관유형을 변경해주세요.</p>

      <p>
        The PCCC(Personal Customs Clearance Code) we got ({{ logi.idno }}) does
        not exist or expired.
      </p>
      <p>
        <a
          target="_blank"
          href="https://unipass.customs.go.kr/csp/persIndexRectOnslCrtf.do?qryIssTp=2"
          >Click here and issue a new PCCC and input in the PCCC box.</a
        >
      </p>
      <p>
        You cannot use Alien Registration Card Number or Passport Number. Please
        get a PCCC number.
      </p>
    </b-card>
    <b-card class="mb-5" v-else-if="errorType === 'WRONG_PHONE'">
      <p>입력하신 휴대전화번호: {{ logi.hand }}</p>
      <p>
        입력하신 휴대전화번호가 개인통관고유부호 신청시의 휴대전화번호와
        일치하지 않습니다
      </p>
      <p>
        휴대전화번호는 반드시 개인통관고유부호 발급자 본인의 휴대전화번호를
        입력하셔야 합니다.
      </p>
      <p>
        <a
          target="_blank"
          href="https://unipass.customs.go.kr/csp/persIndexRectOnslCrtf.do?qryIssTp=1"
          >여기를 클릭하여 신청 당시 휴대전화번호를 확인하신 후 명의자
          휴대전화번호 입력란에 입력해주세요.</a
        >
      </p>
      <p class="text-danger">
        주의: 개인통관고유부호 등록/수정 하실 때 일반전화 입력란과 휴대전화번호
        입력란이 있습니다. 반드시 일반전화가 아닌 휴대전화번호 입력란에
        입력해주세요.
      </p>
      <p>
        통관부호 명의자 휴대전화번호와 수령인 휴대전화번호가 다를 경우 주소란 끝
        부분에 수령인 휴대전화번호를 기입해드립니다.
      </p>

      <p>
        The Phone number we got ({{ logi.hand }}) does not match with the phone
        number you put when you registered your PCCC(Personal Customs Clearance
        Code).
      </p>
      <p>Please submit the correct phone number.</p>
      <p>
        If you want to keep this phone number, please change the Clearance Type
        to use your Alien Registration Card Number or Passport Number.
      </p>
    </b-card>
    <b-card class="mb-5" v-else-if="errorType === 'WRONG_NAME'">
      <p>입력하신 성명: {{ logi.name }}<br /></p>
      <p>입력하신 성명과 개인통관고유부호 신청시의 성명과 일치하지 않습니다</p>
      <p>
        성명은 반드시 개인통관고유부호 발급자 본인의 성명을 입력하셔야 합니다.
      </p>
      <p>
        통관부호 명의자 성명과 수령인 성명이 다를 경우 주소란 끝 부분에 수령인
        성명을 기입해드립니다.
      </p>

      <p>
        The name we got ({{ logi.name }}) does not match with the name you put
        when you registered your PCCC(Personal Customs Clearance Code).
      </p>
      <p>Please submit the exact name on file.</p>
      <p>
        You can also change the Clearance Type to use your Alien Registration
        Card Number or Passport Number.
      </p>
    </b-card>

    <b-card class="shadow-sm">
      <div class="mb-3">
        <h5 class="mb-1">개인통관번호 정보 제출</h5>
        <small class="text-muted">
          입력하신 정보는 통관번호 확인을 위해서만 사용됩니다.
        </small>
      </div>

      <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
        <b-form @submit.prevent="validate().then(onSubmit)">
          <b-row>
            <b-col
              xs="12"
              sm="6"
              class="mb-3"
              :key="field.key"
              v-for="field of editForm"
              v-if="field.show"
            >
              <ValidationProvider
                :rules="field.rules"
                v-slot="{ errors }"
                :name="field.label"
              >
                <b-form-group
                  :label="field.label || field.key"
                  :label-for="field.key"
                  label-class="text-muted"
                  class="mb-1"
                >
                  <b-radio-group
                    v-if="field.key === 'idtype'"
                    v-model="field.value"
                    :options="idTypeRadios"
                    @change="changeIdType($event)"
                  ></b-radio-group>
                  <b-form-input
                    v-else
                    :id="field.key"
                    v-model.trim="field.value"
                    :type="field.type || 'text'"
                    :inputmode="field.inputmode"
                    :placeholder="field.placeholder || ''"
                    :autocomplete="field.autocomplete || 'off'"
                  />
                </b-form-group>
                <small class="text-danger validate-error">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </b-col>
          </b-row>

          <b-alert
            v-if="matchResultKr || matchResultEn"
            show
            variant="danger"
            class="mt-2 mb-0"
          >
            <div>{{ matchResultKr }}</div>
            <div>{{ matchResultEn }}</div>
          </b-alert>

          <div class="mt-4">
            <b-btn type="submit" variant="primary" :disabled="invalid">
              제출하기
            </b-btn>
          </div>
        </b-form>
      </ValidationObserver>
    </b-card>

    <!--    <b-modal id="payment" @ok="createLink" hide-header>-->
    <!--      -->
    <!--    </b-modal>-->
    <!---->
    <!---->
    <!--    <b-alert-->
    <!--      v-model="combinedOrders.length > 0"-->
    <!--      class="position-fixed fixed-bottom m-0 rounded-0 text-center"-->
    <!--      style="z-index: 2000;"-->
    <!--      variant="warning"-->
    <!--    >-->
    <!--      <p> {{ combinedOrders.join(", ") }}</p>-->
    <!--      <p v-if="combinedOrders.length === 1">{{ $t('Choose items to combine.') }}</p>-->
    <!--      <b-btn v-else @click="combineOrders">{{ $t('Combine above orders') }}</b-btn>-->
    <!--    </b-alert>-->
  </b-container>
</template>

<script>
// import 'axios-progress-bar/dist/nprogress.css'
// import { loadProgressBar } from 'axios-progress-bar'
//
// loadProgressBar()

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate/dist/vee-validate.full";
// from "vee-validate";
import { required } from "vee-validate/dist/rules";

export default {
  name: "SubmitId",
  metaInfo: {
    title: "쿠팡고객 개인통관번호 입력폼",
  },
  components: {
    DateRangePicker,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      matchResultKr: "",
      matchResultEn: "",
      logi: {},
      msg: "",
      errorType: "",
      idTypeRadios: [
        {
          text: "개인통관고유부호 (Personal Customs Clearance Code)",
          value: 4,
        },
        { text: "사업자등록번호", value: 2 },
      ],
      editForm: [
        {
          key: "idtype",
          label: "통관유형 (Clearance Type)",
          value: "4",
          rules: "required",
          show: true,
        },
        {
          key: "name",
          label: "개인통관고유부호 명의자 성명 (Full name on the PCCC record)",
          value: "",
          rules: "required",
          show: true,
        },
        {
          key: "hand",
          label:
            "개인통관고유부호 명의자 휴대전화번호 (Phone number on the PCCC record)",
          value: "",
          rules: "required",
          show: true,
        },
        {
          key: "zip",
          label: "우편번호 (Zip Code)",
          value: "",
          rules: "required",
          placeholder: "우편번호 (Zip Code)",
          autocomplete: "postal-code",
          type: "text",
          inputmode: "numeric",
          show: true,
        },
        {
          key: "recipientName",
          label: "수령인 성명 (Recipient Name)",
          value: "",
          show: false,
        },
        {
          key: "recipientPhone",
          label: "수령인 휴대전화번호 (Recipient Phone Number)",
          value: "",
          show: false,
        },
        {
          key: "nationality",
          label: "국적 (Nationality)",
          value: "",
          rules: "required",
          show: false,
        },
        {
          key: "idno",
          label: "개인통관고유부호 (Personal Customs Clearance Code)",
          value: "",
          rules: { required: true },
          show: true,
        },
      ],
    };
  },
  computed: {
    formData() {
      const formData = {};
      this.editForm.forEach((field) => {
        formData[field.key] = field.value;
      });
      return formData;
    },
  },
  methods: {
    isZipMismatchMessage(message) {
      return (
        typeof message === "string" &&
        (message.includes("입력하신 우편번호가") ||
          message.includes("우편번호가 개인통관고유부호"))
      );
    },
    idRule() {
      if (this.formData.idtype === 4) {
        return {
          required: true,
          regex: /P[0-9]{12}/,
        };

        // this.$warn(
        //   "통관부호 격식이 올바르지 않습니다. Not a correct PCCC format."
        // );
      } else if ([1, 6].includes(this.formData.idtype)) {
        return {
          required: true,
          regex: /\d{6}-?\d{7}/,
        };
        // this.$warn(
        //   "등록번호 격식이 올바르지 않습니다. Not a correct registration number format."
        // );
      } else {
        return { required: true };
      }
    },
    async onSubmit(isValidated) {
      if (!isValidated) {
        return false;
      }
      this.matchResultKr = "통관번호 일치 여부를 확인중입니다...";
      this.matchResultEn = "Checking if the PCCC number is valid...";
      const oldZip = this.logi.zip || this.$route.params.phone;
      const requestedZip = this.formData.zip || oldZip;
      const data = await this.$post(
        `/edit-logis/${this.$route.params.idx}/${oldZip}?status=${this.logi.status}`,
        { ...this.formData, zip: requestedZip },
      );
      console.log(data);
      if (data.success) {
        if (data.message === "Success (Correct PCCC)") {
          data.messageKr = `통관부호 매칭에 성공하였습니다. 최대한 빠른 주문처리 해드리겠습니다. 감사합니다.`;
          data.messageEn = `The PCCC ID has been matched successfully. We will ship your order as soon as possible. Thank you.`;
        } else if (data.message === "Success (Non-PCCC ID)") {
          data.messageKr = `입력하신 번호로 통관을 처리해드리겠습니다. 감사합니다.`;
          data.messageEn = `The PCCC ID has been matched successfully. We will ship your order as soon as possible. Thank you.`;
        } else if (data.message === "OK") {
          data.messageKr = "수정완료 되었습니다.";
          data.messageEn = "Edited successfully.";
        }
      } else if (!data.success) {
        if (data.message.includes(" 성명과 일치하지 않습니다")) {
          data.messageKr = `입력하신 통관부호 명의자 성명이 통관부호 신청시의 성명과 일치하지 않습니다.`;
          data.messageEn = `The name you entered does not match the name on file.`;
        } else if (
          data.message.includes("납세의무자 휴대전화번호가 일치하지 않습니다.")
        ) {
          data.messageKr = `입력하신 휴대전화번호가 개인통관고유부호 신청시 입력하신 휴대전화번호와 일치하지 않습니다. 개인통관고유부호 입력시 정확한 번호를 입력하셨는데도 이 메시지가 나오는 경우라면 통관부호 신청시 휴대전화번호 입력란이 아닌 일반전화 입력란에 휴대전화번호를 입력하신 것이 아닌지 확인해 주세요.`;

          data.messageEn = `
          The phone number does not match the one on file. Be sure to put your phone number on the cell phone number field (not the landline phone number) on the PCCC registration form.`;
        } else {
          data.messageKr = data.message || "";
          data.messageEn = "The PPPC number does not exist or is not valid.";
          if (this.isZipMismatchMessage(data.messageKr)) {
            data.messageKr = `${data.messageKr}\n관세청 개인통관고유부호 발급 시스템(https://unipass.customs.go.kr/per/retrievePersEcmEditRect.do?) 에 들어가셔서 조회/재발급/해지 를 클릭한 후 배송지를 추가해주세요(제일 하단에 있습니다).`;
            data.messageEn = `${data.messageEn}\nPlease go to the Customs Clearance Code issuance system (https://unipass.customs.go.kr/per/retrievePersEcmEditRect.do?) and click 조회/재발급/해지, then add your shipping address (at the very bottom).`;
          }
        }
      }

      this.matchResultKr = data.messageKr;
      this.matchResultEn = data.messageEn;
    },
    fillData(editForm, logi) {
      for (const elm of editForm) {
        if (elm.key === "idno" && this.errorType === "WRONG_PCCC") continue;
        else if (elm.key === "hand" && this.errorType === "WRONG_PHONE")
          continue;
        else if (
          elm.key === "recipientPhone" &&
          this.errorType === "WRONG_PHONE"
        ) {
          elm.value = logi.hand;
          elm.show = true;
        } else if (
          elm.key === "recipientName" &&
          this.errorType === "WRONG_NAME"
        ) {
          elm.value = logi.name;
          elm.show = true;
        } else if (elm.key === "name" && this.errorType === "WRONG_NAME")
          continue;
        else elm.value = logi[elm.key];

        if (elm.key === "idno") {
          elm.rules = this.idRule();
        }
      }
    },
    changeIdType(type) {
      console.log(type);
      const idTypeText = this.idTypeRadios.find(
        (radio) => radio.value === type,
      ).text;
      this.editForm.find((field) => field.key === "idno").rules = this.idRule();
      if (type === 2) {
        this.editForm.find((field) => field.key === "name").label =
          "상호 또는 회사명";
        this.editForm.find((field) => field.key === "hand").label = "전화번호";
      } else {
        this.editForm.find((field) => field.key === "name").label =
          "명의자 성명 (Full name on record)";
        this.editForm.find((field) => field.key === "hand").label =
          "명의자 휴대전화번호 (Phone number on record)";
      }
      if (type === 7) {
        this.editForm.find((field) => field.key === "nationality").show = true;
      } else {
        this.editForm.find((field) => field.key === "nationality").show = false;
      }
      this.editForm.find((field) => field.key === "idno").label = idTypeText;
    },
    async init() {
      const { idx, phone } = this.$route.params;
      const zipField = this.editForm.find((field) => field.key === "zip");
      if (zipField && !zipField.value) {
        zipField.value = phone;
      }
      const logi = await this.$get(`/get-idno/${idx}/${phone}`);
      if (!logi) {
        const fallbackZip = zipField ? zipField.value : undefined;
        this.logi = { zip: fallbackZip, status: -1 };
        return;
      }
      if (logi.savemsg.match(/존재하지 않습니다.|현재 사용중이 아닌/)) {
        this.errorType = "WRONG_PCCC";
      } else if (
        logi.savemsg === "납세의무자 휴대전화번호가 일치하지 않습니다."
      ) {
        this.errorType = "WRONG_PHONE";
        this.editForm.find((field) => field.key === "hand").show = true;
      } else if (
        logi.savemsg.includes("개인통관고유부호의 성명과 일치하지 않습니다.")
      ) {
        this.editForm.find((field) => field.key === "name").show = true;
        this.errorType = "WRONG_NAME";
      }
      this.logi = logi;
      this.fillData(this.editForm, logi);
    },
  },
  watch: {
    currentPage(newPage) {
      console.log(newPage);
      this.$router.push({
        params: { page: newPage },
        query: this.$route.query,
      });
      this.init();
    },
    $route: "init",
    "$store.state.user.nick": "init",
  },
  async mounted() {
    this.init();
  },
};
</script>
<style>
.table-canceled {
  text-decoration: line-through;
}

.table-canceling {
  background-color: lightgray;
  text-decoration: line-through;
}

.manage-data {
  width: 19%;
  display: inline;
  margin-right: 1%;
}

.hidden_header {
  display: none;
}
</style>
